import { render, staticRenderFns } from "./CRUDSituacoes.vue?vue&type=template&id=04583828&"
import script from "./CRUDSituacoes.vue?vue&type=script&lang=js&"
export * from "./CRUDSituacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports